import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Tag } from 'antd';
import { formatCrashPercentageString } from 'utils/format/format-number';
import { ze } from 'utils/zhEn';
import { isNotNullish } from 'utils/nullish';

const TOP_N = 5;

export const WangZheTopFormListUtil = Object.freeze({
  /**
   * 计算王者卡顿top标签的结果列表
   * @param {Array} topFormList - 原始的topForm列表
   * @returns {Array} 处理后的结果列表（包含top N和其他项）
   */
  calculateResultList(topFormList) {
    if (!topFormList || topFormList.length === 0) {
      return [];
    }
    
    const enrichedList = topFormList.map(x => {
      const { matchedCount, totalCount } = x;
      const percentage = totalCount > 0 ? Math.floor(100 * matchedCount / totalCount) : 0;
      return {
        ...x,
        percentage,
      };
    });
    
    const topFormListTopN = enrichedList.slice(0, TOP_N);
    let otherItem = null;
    if (enrichedList.length > TOP_N) {
      const totalCount = enrichedList[0].totalCount;
      otherItem = {
        name: ze('其他', 'Others'),
        matchedCount: totalCount - topFormListTopN.reduce((acc, cur) => acc + cur.matchedCount, 0),
        percentage: 100 - topFormListTopN.reduce((acc, cur) => acc + cur.percentage, 0),
        totalCount: enrichedList[0].totalCount,
      };
    }

    return isNotNullish(otherItem) ? [...topFormListTopN, otherItem] : topFormListTopN;
  },

  /**
   * 格式化结果列表为文本（用于下载）
   * @param {Array} resultList - 结果列表
   * @returns {string} 格式化的文本，每个item一行
   */
  formatResultListAsText(resultList) {
    if (!resultList || resultList.length === 0) {
      return '';
    }
    return resultList.map(x => `${x.name} (${x.percentage}%)`).join('\n');
  },
});

const WangZheTopFormList = ({
  issueId,
  issueIdToWangZheTopFormList,
}) => {
  if (!issueIdToWangZheTopFormList || !issueIdToWangZheTopFormList[issueId]) {
    return null;
  }
  
  const topFormList = issueIdToWangZheTopFormList[issueId] || [];
  const resultList = WangZheTopFormListUtil.calculateResultList(topFormList);

  return <div>{
    resultList.map(x => {
      const { name, percentage } = x;
      return <Tag color='geekblue'>{ name } ({ percentage }%)</Tag>
    })
  }</div>;
};

export default WangZheTopFormList;
